'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorMessage = require('./ErrorMessage');

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _tooltip = require('../tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// id is a required prop of tooltip, so return something truthy.
var getTooltipId = function getTooltipId(id, htmlFor) {
  if (id) {
    return id + 'Tooltip';
  }
  if (htmlFor) {
    return htmlFor + 'Tooltip';
  }
  return 'formGroupTooltip';
};

var FormGroup = function FormGroup(props) {
  var id = props.id,
      htmlFor = props.htmlFor,
      text = props.text,
      tooltipText = props.tooltipText,
      labelClassName = props.labelClassName,
      children = props.children,
      error = props.error,
      className = props.className,
      errorClassName = props.errorClassName;


  var tooltip = tooltipText ? _react2.default.createElement(_tooltip2.default, { hoverText: tooltipText, tooltipText: '', id: getTooltipId(id, htmlFor) }) : null;

  return _react2.default.createElement(
    'div',
    { id: id, className: error ? 'pxl-form-group pxl-has-error ' + className : 'pxl-form-group ' + className },
    _react2.default.createElement(
      _label2.default,
      { htmlFor: htmlFor, text: text, className: labelClassName },
      tooltip
    ),
    children,
    _react2.default.createElement(_ErrorMessage2.default, { error: error, className: errorClassName })
  );
};

FormGroup.propTypes = {
  className: _propTypes2.default.string,
  error: _propTypes2.default.string,
  errorClassName: _propTypes2.default.string,
  htmlFor: _propTypes2.default.string,
  id: _propTypes2.default.string,
  labelClassName: _propTypes2.default.string,
  text: _propTypes2.default.string,
  tooltipText: _propTypes2.default.string
};

FormGroup.defaultProps = {
  className: '',
  errorClassName: '',
  id: '',
  labelClassName: ''
};

exports.default = FormGroup;